import { GenericDataType } from "./GenericDataType";

export class ExcelColumn {
    dataType: GenericDataType = GenericDataType.string;
    width: number = null;
}
